var productRecommendationsSections = document.querySelectorAll(
  '.product-recommendation-data'
);
productRecommendationsSections.forEach(function (element) {
  var handleIntersection = function (entries, observer) {
    if (!entries[0].isIntersecting) {
      return;
    }
    observer.unobserve(element);
    var url = element.dataset.url;
    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var recommendations = html.querySelector('[data-recommendation]');
        if (recommendations && recommendations.innerHTML.trim().length) {
          element.innerHTML = recommendations.innerHTML;
        }

        var recommendationElements = element.querySelectorAll(
          '[data-recommendation-content-id][data-recommendation-content-type]'
        );

        var selectRecommendation = function (event) {
          var recommendationEvent = new CustomEvent(
            'performance.selectContent',
            {
              detail: {
                content_type: event.target.dataset.recommendationContentType,
                content_id: event.target.dataset.recommendationContentId
              }
            }
          );
          window.dispatchEvent(recommendationEvent);
        };

        if (recommendationElements) {
          recommendationElements.forEach(function (recommendation) {
            recommendation.addEventListener('click', function (event) {
              selectRecommendation(event);
            });
          });
        }
      })
      .catch(function (e) {
        console.error(e);
      });
  };

  var observer = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px 1000px 0px'
  });

  observer.observe(element);
});
